var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';
import { AlertIDType } from '../../../const/alertsConfig';
import { getPurchaseExceedsValue } from '../../../redux/selectors';
import { getHeaderTitle } from './getHeaderTitle';
import { Title } from './subcomponents';
var AlertTitle = function (_a) {
    var alertID = _a.alertID, inputValue = _a.inputValue;
    var t = useTranslation().t;
    var stringKey = alertID.toLowerCase();
    // logic for different header names in approved transactions
    var purchaseExceedsValue = useSelector(getPurchaseExceedsValue, shallowEqual);
    var isPurchaseExceedAlert = stringKey === AlertIDType.APPROVED_TRANSACTIONS.toLowerCase() &&
        inputValue === AlertIDType.PURCHASE_EXCEEDS;
    var isTransAuthAlert = stringKey === AlertIDType.APPROVED_TRANSACTIONS.toLowerCase() &&
        inputValue === AlertIDType.TRANSACTION_AUTHORIZATION;
    var updatedInputValue = isPurchaseExceedAlert
        ? purchaseExceedsValue
        : inputValue;
    if (isTransAuthAlert) {
        stringKey = AlertIDType.TRANSACTION_AUTHORIZATION.toLowerCase();
    }
    if (isPurchaseExceedAlert) {
        stringKey = AlertIDType.PURCHASE_EXCEEDS.toLowerCase();
    }
    // logic ends
    var tmpTitle = t("alertsTitle.".concat(stringKey))
        ? t("alertsTitle.".concat(stringKey))
        : "Undefined Alert Title for ".concat(stringKey);
    var titleParts = getHeaderTitle(tmpTitle, updatedInputValue);
    return (_jsx(Title, __assign({ "data-test": "Title" }, { children: titleParts.map(function (part) { return (_jsx(React.Fragment, { children: part }, part.toString())); }) })));
};
export default AlertTitle;
